$(document).ready(function () {
  // FAQ Magic
  $("#faq-template-wrapper > div:first-child").addClass("faq-target");

  $("a.numbered").each(function (index) {
    var num = index + 1;
    $(this).html(num);
  });

  $("#faq-template-wrapper p > strong").parent().each(function (i) {
    $(this).addClass("accordion-toggle");
    let children = $(this).nextUntil( $("#faq-template-wrapper p > strong").parent() );
    children.wrapAll("<div class='accordion-panel no-ae' />");
    //     let label  = $(this).text();
    let num = i + 1;
    let target = "itemqa-" + num;
    //     let menuItem = '<li><a href="#'+target+'">'+label+'</a></li>';
    $(this).attr("id", target);
    $(this).prepend("<span class='num'>#" + num + "</span> ");
    //     $holdMenu.find('#faq-menu-holder').append( menuItem );
  });

  $("#faq-template-wrapper p > strong").parent().on("click", function (i) {
    $(this).toggleClass("open");
  });
});
